const header = {
  header: {
    logOut: 'Log out',
    enphaseStore: 'Enphase Store',
    enphaseSupport: 'Enphase Support',
    comingSoon: 'Coming Soon',
    new: 'new'
  }
};

export default header;
